import React from 'react';

import {
  UserConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

export const useViewConnection = () => {
  const {
    handleShowDeleteModal,
    handleUpdateOverlayMode,
    handleUpdateUserConnectionModalScreen,
    handleUpdateSelectedConnection,
  } = useSFConnectionState();

  const handleClose = (event: React.SyntheticEvent) => {
    event.preventDefault();

    handleUpdateOverlayMode('none');
    handleUpdateSelectedConnection(null);
  };

  const handleEdit = (event: React.SyntheticEvent) => {
    event.preventDefault();

    handleUpdateUserConnectionModalScreen(
      UserConnectionModalScreens.CONNECTION_EDIT_SCREEN,
    );
  };

  const handleDelete = (event: React.SyntheticEvent) => {
    event.preventDefault();

    handleShowDeleteModal();
  };

  return {
    handleClose,
    handleEdit,
    handleDelete,
  };
};
